<template>
  <div>
    <app-search />
    <div style="margin: 20px">لطفا یکی از دوره های زیر را انتخاب نمایید:</div>
    <div v-if="isMobile">
      <v-card v-for="item in items" :key="item.Value">
        <v-card-title class="info-detail">
          <v-radio-group v-model="selectedReshte">
            <v-radio label="" :value="item"></v-radio>
          </v-radio-group>
          <div class="text-center">
            {{ item.Text }}
          </div>
        </v-card-title>
        <div
          class="contain"
          :style="[
            selectedReshte != null && item.Value == selectedReshte.Value
              ? { 'background-color': '#00d10040' }
              : '',
          ]"
        >
          <app-row icon="hashtag" title="کد : " :value="item.Value" />
        </div>
      </v-card>
    </div>
    <div v-else>
      <v-data-table
        :headers="headers"
        :items="items"
        item-key="Value"
        show-select
        single-select
        class="elevation-1 rounded2"
        :no-data-text="tableText"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
        }"
      >
        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>
        <template v-slot:[`item.data-table-select`]="{ item }">
          <v-radio-group v-model="selectedReshte">
            <v-radio label="" :value="item"></v-radio>
          </v-radio-group>
        </template>
      </v-data-table>
    </div>
    <app-actions
      @nextStep="nextStep"
      :showCancel="true"
      @prevStep="prevStep"
    ></app-actions>
  </div>
</template>

<script>
import Actions from "./Actions";
import DetailRow from "@/components/DetailRow";
import Search from "@/components/Search";
export default {
  components: {
    appActions: Actions,
    appRow: DetailRow,
    appSearch: Search,
  },
  data() {
    return {
      selectedReshte: null,
      headers: [
        {
          text: "سریال",
          value: "Value",
          width: "20%",
          sortable: false,
        },

        {
          text: "نام دوره",
          value: "Text",
          width: "80%",
        },
      ],
    };
  },
  props: ["items"],
  methods: {
    nextStep() {
      if (this.selectedReshte == null) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "دوره ای برای تدریس انتخاب نشده است."
        );

        return;
      } else {
        this.$emit("nextStep", this.selectedReshte);
      }
    },
    prevStep() {
      this.$emit("prevStep");
    },
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
};
</script>

